import { DatePipe } from '@angular/common';
import { LoanApplicationModel } from '../../disclosure/models/loan-application.model';
import { ILoanStatusCard, LoanStatusCardConfig, LoanStatusCardType } from './loan-status-card.model';
import { DisclosureDates } from '../../disclosure/models/disclosure-dates.model';
import { IdValue, LoanItemStatus, LoanItemStatusIconType } from '../../shared/models';
import { dateLessThanNow } from '../../shared/utils';
import { LoanStatus } from '../../cmg-1003/models';

export const GetDisclosuresStatus = (
  disclosureLoanModel: LoanApplicationModel,
  dates: DisclosureDates,
  status?: IdValue<string, string, string>,
): ILoanStatusCard => {
  const cardBase = LoanStatusCardConfig.find((c) => c.cardType === LoanStatusCardType.Disclosures);
  const card = <ILoanStatusCard>{ ...cardBase, cardType: LoanStatusCardType.Disclosures };
  const applicationDate = disclosureLoanModel?.applicationDate || '';
  const disclosureDeadline = dates?.disclosureDeadline || '';
  const orderedDateTime = disclosureLoanModel?.orderedDateTime || '';
  const isLoanStatusLEPending = Number(status?.id ?? 0) === LoanStatus.LePending;
  const initialDisclosuresRequested = dates?.initialDisclosuresRequested ?? '';

  if (isLoanStatusLEPending && initialDisclosuresRequested && !orderedDateTime) {
    const initialDisclosuresRequestedFormated = new DatePipe('en-US').transform(initialDisclosuresRequested, 'M/d/yy');
    card.icon = LoanItemStatusIconType.Circle;
    card.descriptionHtml = `Requested: ${initialDisclosuresRequestedFormated}`;
    card.status = LoanItemStatus.Warning;
    return card;
  }

  if (!applicationDate) {
    card.icon = LoanItemStatusIconType.EmptyCircle;
    card.descriptionHtml = 'Due: Pending';
    return card;
  }

  const disclosureDeadlineFormated = new DatePipe('en-US').transform(disclosureDeadline, 'M/d/yy');

  card.status = LoanItemStatus.NotComplete;

  if (applicationDate && disclosureDeadline) {
    card.icon = LoanItemStatusIconType.Circle;
    card.descriptionHtml = `Due: ${disclosureDeadlineFormated}`;
    card.status = LoanItemStatus.Warning;
  }

  if (dateLessThanNow(disclosureDeadline) && !orderedDateTime) {
    card.icon = LoanItemStatusIconType.Square;
    card.descriptionHtml = `Past Due ${disclosureDeadlineFormated}`;
    card.status = LoanItemStatus.Error;
  }

  if (orderedDateTime) {
    const orderDate = new DatePipe('en-US').transform(orderedDateTime, 'M/d/yy');
    card.icon = LoanItemStatusIconType.Circle;
    card.descriptionHtml = `Date Sent <b>${orderDate}</b>`;
    card.status = LoanItemStatus.Complete;
  }

  return card;
};
